import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorActionEnum, Is_Sign_Action } from 'src/app/constants/actor-action.enum';
import { RequestModel } from 'src/app/models/requests';
import { User } from 'src/app/models/user';
import { PkisigningService } from 'src/app/services/pkisigning.service';

@Component({
  templateUrl: './changesignatureprovider.modal.html'
})
export class ChangesignatureproviderModal implements OnInit {

  @Input('owner') owner!: string;
  @Input('request') request!: RequestModel;
  @Input('user') user!: User;
  @Input('eSeal') eSeal: boolean = false;
  @Input('signatureProvider') signatureProvider!: any;
  @Input('signatureProviderName') signatureProviderName!: any;
  @Input('signatureProviders') signatureProviders!: any;
  @Input('jobname') jobname!: string;
  @Output('sign') sign = new EventEmitter();
  @Output('changeSigningMethod') changeSigningMethod = new EventEmitter();
  @Output('newSignMethod') newSignMethod = new EventEmitter();
  @Output('signsession') signsession = new EventEmitter();

  changeMethod: boolean = false;
  changeSignMethod: boolean = false;
  nextAction: any;
  public buttonsEnabled: boolean = true
  selectedSigningProvider: any;

  constructor(public activeModal: NgbActiveModal, private pkisigning: PkisigningService) {
  }

  ngOnInit(): void {
    this.nextAction = this.currentAction();
    this.getSignatureProviders();
  }

  private getSignatureProviders() {
    this.pkisigning.getSignatureProviders();
  }

  getNewSignMethod(event: any) {
    this.selectedSigningProvider = event;
    this.newSignMethod.emit(event);
  }

  changeSignatureProvider(providerProfile: any) {
    this.pkisigning.changeSignatureProvider(providerProfile.signatureProviderType, providerProfile.parameters);
  }

  back() {
    this.signsession.emit("close");
  }

  async startSignflow() {
    this.buttonsEnabled = false;
    await this.changeSignatureProvider(this.selectedSigningProvider);

    if (this.request.dossierType.toLocaleLowerCase() !== "pdf") {
      if (Is_Sign_Action(this.nextAction[0].action))
        this.Sign();
    }
  }

  disableSignButton() {
    if (!this.buttonsEnabled) {
      return true;
    } else {
      return false;
    }
  }

  public async Sign() {
    let signAction: any = {
      action: ActorActionEnum.Sign,
      documentId: this.currentAction()[0].documentId
    };
    this.sign.emit(signAction);
  }

  public currentAction() {
    return this.request.actors.filter(a => a.email == this.user.email && a.mobile == this.user.phoneNumber && !a.hasSigned).sort((a, b) => { return a.order - b.order; });
  }
}
